
export function getPlatform(): 'android' | 'ios' | 'desktop' {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/android/i.test(ua)) {
    return 'android';
  }

  const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  if (isIOS) {
    return 'ios';
  }

  return 'desktop';
}